import MainMenu from '@/components/foundation/main-menu/MainMenu'
import Cbpf from '@/view/record/cbpf/Cbpf'

export default {
  path: '/cbpf',
  name: 'Cbpf',
  components: {
    default: Cbpf,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'record',
    area: 'record-user',
    breadcrumb: [
      { name: 'Cadastro', link: '/record' },
      { name: 'CBPF' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/record/CbpfRoute.js